import moment from 'moment';

export const getColName = (
  period: Period,
  cadence: 'week' | 'month' | 'fiscalPeriod',
  isFull?: boolean,
): string => {
  if (cadence === 'month') {
    return moment(period.startDate).format(isFull ? "MMMM 'YY" : "MMM 'YY");
  } else {
    return isFull
      ? `${moment(period.startDate).format('MMM DD')} - ${moment(
          period.endDate,
        ).format('MMM DD')}`
      : period.label;
  }
};
